export const basicInformations = {
  onboardingSteps: [
    {
      key: 'deadline',
      name: 'Basic Details',
      status: 'empty',
      type: 'single',
      hero: 'Basic Details',
      description: "Let's name your project and set a due date.",
      selectedValue: [],
      cards: [
        {
          isSpecial: true,
          value: 'deadline',
        },
      ],
    },
    {
      key: 'type',
      name: 'Type',
      status: 'empty',
      type: 'single',
      hero: 'Choose your project category',
      description: "Select the type of video you're looking to create.",
      selectedValue: [],
      cards: [
        {
          label: 'Ad',
          text: 'Direct Response, Brand Awareness, Consideration',
          value: 'social_digital_ad',
        },
        {
          label: 'Animated Explainers',
          text: 'How-To, Product walkthrough, Recipe',
          value: 'explainers',
        },
        // {
        //   label: 'Static to Video',
        //   text: 'Videos created entirely from static images',
        //   value: 'online_course',
        // },
        {
          label: 'Sizzle Reels',
          text: 'Short promotional highlight videos',
          value: 'sizzle_reel',
        },
        {
          label: 'Editorials',
          text: 'Teaser videos meant to inform, educate, or entertain',
          value: 'editorial',
        },
        {
          label: 'Testimonials',
          text: 'Videos showcasing your clients to establish trust',
          value: 'interviews',
        },
      ],
    },
    {
      key: 'basic_requirements',
      status: 'empty',
      name: 'Basic Requirements',
      type: 'multiple_choice',
      hero: 'What are the basic requirements for this video?',
      description: 'Select all that apply',
      selectedValue: [],
      cards: [
        {
          label: 'Pre-production',
          text: 'Help with strategy and concepting',
          value: 'pre_production',
        },
        {
          label: 'Production',
          text: 'A team to shoot a live video',
          value: 'production',
        },
        {
          label: 'Animation',
          text: 'Original motion graphics',
          value: 'animation',
        },
        {
          label: 'Video Editing',
          text: 'Selecting and sequencing the best shots',
          value: 'video_editing',
        },
      ],
    },
    {
      key: 'production',
      name: 'Production',
      status: 'empty',
      type: 'single',
      disabled: true,
      hero:
        'Since you indicated that you want video production, which type of video are you looking to produce?',
      description:
        "This will determine the crew we will need to film your shoot. If you don't need video production, go back to Step 1 to edit your basic requirements.",
      selectedValue: [],
      cards: [
        {
          label: 'Brand',
          text: '',
          value: 'brand',
          wideImage: true,
        },
        {
          label: 'Commercial',
          text: '',
          value: 'commercial',
          wideImage: true,
        },
        {
          label: 'Event',
          text: '',
          value: 'event',
          wideImage: true,
        },
        {
          label: 'Product',
          text: '',
          value: 'product',
          wideImage: true,
        },
        {
          label: 'Testimonial/Interview',
          text: '',
          value: 'testimonial_interview',
          wideImage: true,
        },
        {
          label: 'Drone',
          text: '',
          value: 'drone',
          wideImage: true,
        },
        {
          label: 'Other',
          text: '',
          value: 'other',
          containInput: true,
          placeholder: 'Add your own category.',
        },
        {
          label: "I don't know",
          text: 'Unsure? Our creative services team can help!',
          value: 'dont_know',
          is_hand: true,
        },
      ],
    },
    {
      key: 'animation',
      status: 'empty',
      name: 'Animation',
      type: 'single',
      hero: 'Which style of animation is closest to what you are looking for?',
      description:
        'Since you selected animation, let us know which style you prefer.',
      selectedValue: [],
      cards: [
        {
          label: 'Character/Cartoon Based',
          text: '',
          value: 'cartoon_based',
          wideImage: true,
        },
        {
          label: 'Line Art',
          text: '',
          value: 'line_art',
          wideImage: true,
        },
        {
          label: 'Infographic',
          text: '',
          value: 'infographic',
          wideImage: true,
        },
        {
          label: '3D Animation',
          text: '',
          value: '3d_animation',
          wideImage: true,
        },
        {
          label: 'Whiteboard',
          text: '',
          value: 'whiteboard',
          wideImage: true,
        },
        {
          label: 'Kinetic Text',
          text: '',
          value: 'kinetic_text',
          wideImage: true,
        },
        {
          label: '2D Vector',
          text: '',
          value: '2d_vector',
          wideImage: true,
        },
        {
          label: 'Motion Tracking',
          text: '',
          value: 'motion_tracking',
          wideImage: true,
        },
      ],
    },
    {
      key: 'tone',
      name: 'Tone',
      status: 'empty',
      type: 'single',
      hero: 'Choose your project tone.',
      description: "Which tone best fits the video you're looking to create?",
      selectedValue: [],
      cards: [
        {
          label: 'Light/Witty',
          text: '',
          value: 'light',
        },
        {
          label: 'Inspirational',
          text: '',
          value: 'inspirational',
        },
        {
          label: 'Professional/Corporate',
          text: '',
          value: 'professional',
        },
        {
          label: 'Comedic',
          text: '',
          value: 'comedic',
        },
        {
          label: 'Heartfelt',
          text: '',
          value: 'romantic',
        },
        {
          label: 'Educational',
          text: '',
          value: 'educational',
        },
        {
          label: 'Other',
          text: '',
          value: 'other',
          containInput: true,
          placeholder: 'Add your own category.',
        },
        {
          label: "I don't know",
          text: 'Unsure? Our creative services team can help!',
          value: 'dont_know',
          is_hand: true,
        },
      ],
    },
    {
      key: 'duration',
      name: 'Duration',
      status: 'empty',
      type: 'single',
      hero: 'How long should the video be?',
      description:
        'Have a goal in mind or strict parameters on how long the video needs to be?',
      selectedValue: [],
      cards: [
        {
          label: ':6',
          text: 'Best for social ads',
          value: ':6',
        },
        {
          label: ':15',
          text: 'Instantly grab attention',
          value: ':15',
        },
        {
          label: ':30',
          text: 'Move from awareness to interest',
          value: ':30',
        },
        {
          label: '60',
          text: 'Highlight product features or brand values',
          value: '60',
        },
        {
          label: '90',
          text: 'Highlight product features or brand values',
          value: '90',
        },
        {
          label: 'Up to 2 minutes',
          text: 'Highlight product features or brand values',
          value: 'Up to 2 minutes',
        },
        {
          label: '2+ minutes',
          text: 'Storytelling, education, or interviews',
          value: '2+ minutes',
        },
      ],
    },
    {
      key: 'series',
      name: 'Series or Single',
      status: 'empty',
      type: 'single',
      hero: 'Will this project require a single video or a series?',
      description:
        "If you're looking to create several individual videos from the same content, select series.",
      selectedValue: [],
      cards: [
        {
          label: 'Single Video',
          text: "I'm looking to create just 1 video",
          value: 'single',
        },
        {
          label: 'Multiple Videos',
          text:
            "I want to create multiple videos from the content we're using ",
          value: 'Multiple Videos',
        },
      ],
    },
    {
      key: 'format',
      name: 'Format',
      status: 'empty',
      type: 'multiple_choice',
      hero: 'Video Layouts',
      description: [
        'We specialize in optimizing videos for a variety of platforms.',
        'If there are additional layouts you will need to support, please select them below.',
        'Note: ',
        'By default, all projects will include the standard 16:9 layout unless unselected',
      ],
      selectedValue: ['standard_size'],
      enableSkip: true,
      cards: [
        {
          label: '16:9',
          value: 'standard_size',
          hasBottomImage: true,
        },
        {
          label: '9:16',
          value: 'vertical_2_3',
          hasBottomImage: false,
        },
        {
          label: '4:5',
          value: 'vertical_4_5',
          hasBottomImage: false,
        },
        {
          label: '1:1',
          value: 'square_1_1',
          hasBottomImage: false,
        },
        {
          label: '2:3',
          value: 'full_portrait_vertical_9_16',
          hasBottomImage: false,
        },
        {
          is_hand: true,
          label: 'Google Specific Requirements',
          value: 'Google Specific Requirements',
        },
      ],
    },
     {
      key: 'video_layout',
      name: 'Video layout',
      status: 'empty',
      type: 'multiple_choice',
      hero: 'Video layout',
      description: [
        'We specialize in optimizing videos for a variety of platforms.',
        'If there are additional layouts you will need to support, please select them below.',
        'Note: ',
        'By default, all projects will include the standard 16:9 layout unless unselected',
      ],
      selectedValue: ['standard_size'],
      enableSkip: true,
      cards: [
        {
          label: '16:9',
          value: '16:9',
          hasBottomImage: true,
        },
        {
          label: '9:16',
          value: '9:16',
          hasBottomImage: false,
        },
        {
          label: '4:5',
          value: '4:5',
          hasBottomImage: false,
        },
        {
          label: '1:1',
          value: '1:1',
          hasBottomImage: false,
        },
        {
          label: '2:3',
          value: '2:3',
          hasBottomImage: false,
        },
        {
          is_hand: true,
          label: 'Google Specific Requirements',
          value: 'Google Specific Requirements',
        },
      ],
    },
    {
      key: 'audience',
      name: 'Target Audience',
      status: 'empty',
      type: 'multiple_choice',
      hero: 'Target Audience',
      description:
        'Select all requirements that apply. If your project does not require any, continue to the next step.',
      selectedValue: [],
      disabled: false,
      enableSkip: true,
      cards: [
        {
          label: 'Generation Z',
          text: '',
          value: 'Generation Z',
          noIcon: true,
        },
        {
          label: 'Generation X',
          text: '',
          value: 'Generation X',
          noIcon: true,
        },
        {
          label: 'Baby Boomers',
          text: '',
          value: 'Baby Boomers',
          noIcon: true,
        },
        {
          label: 'Millenials',
          text: '',
          value: 'Millenials',
          noIcon: true,
        },
      ],
    },
    {
      key: 'project_requirements',
      name: 'Project Requirements',
      status: 'empty',
      type: 'multiple_choice',
      hero: 'Project Requirements',
      description:
        'Select all requirements that apply. If your project does not require any, continue to the next step.',
      selectedValue: [],
      disabled: false,
      enableSkip: true,
      cards: [
        {
          label: 'Script / Subtitles',
          text: '',
          value: 'script_subtitles',
          noIcon: true,
        },
        {
          label: 'Creative Concepting/Storyboard',
          text: '',
          value: 'Creative Concepting/Storyboard',
          noIcon: true,
        },
        {
          label: 'Music/Audio',
          text: '',
          value: 'Music/Audio',
          noIcon: true,
        },
        {
          label: 'Copywriting',
          text: '',
          value: 'Copywriting',
          noIcon: true,
        },
        {
          label: 'Creative Best Practices',
          text: '',
          value: 'Creative Best Practices',
          noIcon: true,
        },
        {
          label: 'Stock Assets',
          text: '',
          value: 'Stock Assets',
          noIcon: true,
        },
        {
          label: 'Additional Ratios/Formats',
          text: '',
          value: 'Additional Ratios/Formats',
          noIcon: true,
        },
        {
          label: 'Voiceover',
          text: '',
          value: 'voiceover',
          noIcon: true,
        },
        {
          label: 'Language Translation / Localization',
          text: '',
          value: 'Language Translation / Localization',
          noIcon: true,
        },
      ],
    },
    {
      key: 'url_link',
      status: 'empty',
      name: 'URL Linking',
      type: 'single',
      hero: 'Have Any Video References That Inspire You?',
      description:
        'If so, list it here and let us know what you like about it.',
      references: [{ internal_id: 0, link: '', checkboxes: [], comment: '' }],
      selectedValue: [],
      enableSkip: true,
      cards: [
        {
          isSpecial: true,
          value: 'references_screen',
        },
      ],
    },
    {
      key: 'files',
      status: 'empty',
      name: 'Asset Linking',
      type: 'single',
      hero: 'Provide any files and assets needed.',
      description:
        'Please select how you would like to upload project materials including written briefs, existing footage, graphics, audio files, scripts, storyboards, etc.',
      dropboxPath: null,
      selectedValue: [],
      cards: [
        {
          label: 'Dropbox',
          text: 'Link files to a folder on dropbox',
          value: 'dropbox',
          isSpecial: true,
        },
        {
          label: 'Other',
          text:
            'Send your files electronically via e-mail, or other shared file system.',
          value: 'different_way',
        },
        {
          label: 'No Files',
          text:
            "Don't have files for your project? We'll help you get started!",
          value: 'no_files',
          is_hand: false,
        },
      ],
    },
    {
      key: 'free_comment',
      status: 'empty',
      name: 'URL Linking',
      type: 'single',
      hero: "Is there anything you'd like to add?",
      description: '',
      references: [{ internal_id: 0, link: '', checkboxes: [], comment: '' }],
      selectedValue: [],
      enableSkip: true,
      cards: [
        {
          isSpecial: true,
          value: 'free_comment',
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/reducers/Onboarding/overviewSteps/basicInformations.js